var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1207_6915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 20H0V19.2375L3.30875 12.5781H16.6502L20 19.2359V20Z",
    fill: "#DBDBDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6502 12.5781H10V20H20V19.2359L16.6502 12.5781Z",
    fill: "#C1C1CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0C6.66145 0 3.94531 2.71613 3.94531 6.05469C3.94531 7.10043 4.21668 8.13172 4.73004 9.03711L9.62781 17.2656H10.3722L15.2638 9.04777L15.27 9.03707C15.7833 8.13172 16.0547 7.10043 16.0547 6.05469C16.0547 2.71613 13.3386 0 10 0ZM10 7.61719C9.13707 7.61719 8.4375 6.91762 8.4375 6.05469C8.4375 5.19176 9.13707 4.49219 10 4.49219C10.8629 4.49219 11.5625 5.19176 11.5625 6.05469C11.5625 6.91762 10.8629 7.61719 10 7.61719Z",
    fill: "#4D8AEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 0V4.49219C10.8629 4.49219 11.5625 5.19176 11.5625 6.05469C11.5625 6.91762 10.8629 7.61719 10 7.61719V17.2656H10.3722L15.2638 9.04777L15.27 9.03707C15.7833 8.13172 16.0547 7.10043 16.0547 6.05469C16.0547 2.71613 13.3386 0 10 0Z",
    fill: "#2C73E8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1207_6915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.69463a3928f6dae7833ac9b77b2ffa4d.svg";
export { ForwardRef as ReactComponent };